import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IMagazaCiroAnaliziOzel_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IMagazaCiroAnaliziOzel_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  Logout: boolean;
  Logout_dummy: boolean;
  goToSignInActivity: any;
  goToSignInActivity_dummy: any;
  GetCollectionHeader: any[];
  GetCollectionHeader_dummy: any[];
  GetCollectionReturnHeader: any[];
  GetCollectionReturnHeader_dummy: any[];
  GetPaymentHeader: any[];
  GetPaymentHeader_dummy: any[];
  GetPaymentReturnHeader: any[];
  GetPaymentReturnHeader_dummy: any[];
  GetPaymentSummary: any[];
  GetPaymentSummary_dummy: any[];
  GetStoreInfo: any[];
  GetStoreInfo_dummy: any[];
  GetImage: any[];
  GetImage_dummy: any[];
  GetPaymentReturnSummary: any[];
  GetPaymentReturnSummary_dummy: any[];
  SetValueOf: any;
  SetValueOf_dummy: any;
  isComp324396Visible: "visible" | "hidden";
}

export class MagazaCiroAnaliziOzel_ScreenBase extends React.PureComponent<
  IMagazaCiroAnaliziOzel_ScreenProps,
  any
> {
  magazaciroanaliziozel_633300_value_kuikaSelectBoxRef: React.RefObject<any>;
  magazaciroanaliziozel_965256_value_kuikaSelectBoxRef: React.RefObject<any>;
  magazaciroanaliziozel_905610_value_kuikaDateRef: React.RefObject<any>;
  magazaciroanaliziozel_836291_value_kuikaDateRef: React.RefObject<any>;
  magazaciroanaliziozel_268575_value_kuikaTableRef: React.RefObject<any>;
  magazaciroanaliziozel_196818_value_kuikaTableRef: React.RefObject<any>;
  magazaciroanaliziozel_190713_value_kuikaTableRef: React.RefObject<any>;
  magazaciroanaliziozel_60075_value_kuikaTableRef: React.RefObject<any>;
  magazaciroanaliziozel_255514_value_kuikaTableRef: React.RefObject<any>;
  magazaciroanaliziozel_330689_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "10a0db45-eac7-4ffc-8246-041db2ced344",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "33c0448a-74f3-427e-bef6-fc177329bda2",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 976357, PropertyName: "label", Value: "Profil" },
        { Id: 446097, PropertyName: "label", Value: "Çıkış Yap" },
        { Id: 342102, PropertyName: "value", Value: "Mağaza Ciro Analizi" },
        { Id: 633300, PropertyName: "placeholder", Value: "Mağaza" },
        { Id: 965256, PropertyName: "placeholder", Value: "Zaman Aralığı" },
        { Id: 905610, PropertyName: "placeholder", Value: "Başlangıç Tarihi" },
        { Id: 836291, PropertyName: "placeholder", Value: "Bitiş Tarihi" },
        { Id: 758630, PropertyName: "label", Value: "Filtrele" },
        { Id: 688516, PropertyName: "label", Value: "Temizle" },
        { Id: 919309, PropertyName: "value", Value: "Satışlar" },
        { Id: 426966, PropertyName: "value", Value: "Süreç" },
        { Id: 372754, PropertyName: "value", Value: "Tutar" },
        {
          Id: 268575,
          PropertyName: "nodatafoundmessage",
          Value: "Veri bulunamadı",
        },
        { Id: 707449, PropertyName: "title", Value: "Title" },
        { Id: 56545, PropertyName: "value", Value: "[datafield:surec]" },
        {
          Id: 987265,
          PropertyName: "value",
          Value: "[datafield:doc_netamount]",
        },
        { Id: 394148, PropertyName: "value", Value: "İadeler" },
        { Id: 863308, PropertyName: "value", Value: "Süreç" },
        { Id: 464078, PropertyName: "value", Value: "Tutar" },
        {
          Id: 196818,
          PropertyName: "nodatafoundmessage",
          Value: "Veri bulunamadı",
        },
        { Id: 870530, PropertyName: "title", Value: "Title" },
        { Id: 922674, PropertyName: "value", Value: "[datafield:satistipi]" },
        { Id: 956507, PropertyName: "value", Value: "[datafield:toplamiade]" },
        { Id: 554173, PropertyName: "value", Value: "Tahsilatlar" },
        { Id: 174928, PropertyName: "value", Value: "Ödeme Yönetimi" },
        { Id: 410772, PropertyName: "value", Value: "Tutar" },
        {
          Id: 190713,
          PropertyName: "nodatafoundmessage",
          Value: "Veri bulunamadı",
        },
        { Id: 335958, PropertyName: "title", Value: "Title" },
        { Id: 628285, PropertyName: "value", Value: "[datafield:alttip]" },
        { Id: 869224, PropertyName: "value", Value: "[datafield:tutar]" },
        { Id: 884681, PropertyName: "value", Value: "İade Ödemeleri" },
        { Id: 317649, PropertyName: "value", Value: "Ödeme Yöntemi" },
        { Id: 777865, PropertyName: "value", Value: "Tutar" },
        {
          Id: 60075,
          PropertyName: "nodatafoundmessage",
          Value: "Veri bulunamadı",
        },
        { Id: 152063, PropertyName: "title", Value: "Title" },
        { Id: 592157, PropertyName: "value", Value: "[datafield:alttip]" },
        { Id: 911896, PropertyName: "value", Value: "[datafield:iadetutari]" },
        { Id: 738263, PropertyName: "value", Value: "Taksit Ödemeleri" },
        { Id: 216316, PropertyName: "value", Value: "Ödeme Yöntemi" },
        { Id: 449132, PropertyName: "value", Value: "Tutar" },
        {
          Id: 255514,
          PropertyName: "nodatafoundmessage",
          Value: "Veri bulunamadı",
        },
        { Id: 474050, PropertyName: "title", Value: "Title" },
        { Id: 711719, PropertyName: "value", Value: "[datafield:odemeturu]" },
        { Id: 173377, PropertyName: "value", Value: "[datafield:toplamtutar]" },
        { Id: 645842, PropertyName: "value", Value: "Taksit Ödeme İadeleri" },
        { Id: 416176, PropertyName: "value", Value: "Ödeme Yöntemi" },
        { Id: 711652, PropertyName: "value", Value: "Tutar" },
        {
          Id: 330689,
          PropertyName: "nodatafoundmessage",
          Value: "Veri bulunamadı",
        },
        { Id: 328508, PropertyName: "title", Value: "Title" },
        { Id: 132226, PropertyName: "value", Value: "[datafield:odemeturu]" },
        {
          Id: 895868,
          PropertyName: "value",
          Value: "[datafield:toplamiadetutari]",
        },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);
    this.magazaciroanaliziozel_633300_value_kuikaSelectBoxRef =
      React.createRef();
    this.magazaciroanaliziozel_965256_value_kuikaSelectBoxRef =
      React.createRef();
    this.magazaciroanaliziozel_905610_value_kuikaDateRef = React.createRef();
    this.magazaciroanaliziozel_836291_value_kuikaDateRef = React.createRef();
    this.magazaciroanaliziozel_268575_value_kuikaTableRef = React.createRef();
    this.magazaciroanaliziozel_196818_value_kuikaTableRef = React.createRef();
    this.magazaciroanaliziozel_190713_value_kuikaTableRef = React.createRef();
    this.magazaciroanaliziozel_60075_value_kuikaTableRef = React.createRef();
    this.magazaciroanaliziozel_255514_value_kuikaTableRef = React.createRef();
    this.magazaciroanaliziozel_330689_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
      Logout: false,
      goToSignInActivity: "",
      GetCollectionHeader: [],
      GetCollectionReturnHeader: [],
      GetPaymentHeader: [],
      GetPaymentReturnHeader: [],
      GetPaymentSummary: [],
      GetStoreInfo: [],
      GetImage: [],
      GetPaymentReturnSummary: [],
      SetValueOf: "",
      dataSource_965256: [
        { key: "1", text: "Bugün" },
        { key: "2", text: "Son 7 Gün" },
        { key: "3", text: "Son 1 Ay" },
        { key: "4", text: "Son 3 Ay" },
        { key: "5", text: "Son  6 Ay" },
        { key: "6", text: "Son 1 Yıl" },
        { key: "7", text: "İki Tarih Arası Filtreleme" },
      ],
      isComp324396Visible: "hidden",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("magazaciroanaliziozel", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.MagazaCiroAnaliziOzelPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("magazaciroanaliziozel", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("magazaciroanaliziozel", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.MagazaCiroAnaliziOzelPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      magazaciroanaliziozel_521690_value:
        this.state.GetImage?.at?.(0)?.photo ?? undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  MagazaCiroAnaliziOzelPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      storeCode_0: ReactSystemFunctions.convertToTypeByName(null, "string"),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
      startDate_0: ReactSystemFunctions.convertToTypeByName(null, "Date"),
      endDate_0: ReactSystemFunctions.convertToTypeByName(null, "Date"),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
      storeCode_1: ReactSystemFunctions.convertToTypeByName(null, "string"),
      dateFilter_1: ReactSystemFunctions.convertToTypeByName(1, "number"),
      startDate_1: ReactSystemFunctions.convertToTypeByName(null, "Date"),
      endDate_1: ReactSystemFunctions.convertToTypeByName(null, "Date"),
      pageNumber_1: ReactSystemFunctions.convertToTypeByName(1, "number"),
      storeCode_2: ReactSystemFunctions.convertToTypeByName(null, "string"),
      dateFilter_2: ReactSystemFunctions.convertToTypeByName(1, "number"),
      startDate_2: ReactSystemFunctions.convertToTypeByName(null, "Date"),
      endDate_2: ReactSystemFunctions.convertToTypeByName(null, "Date"),
      pageNumber_2: ReactSystemFunctions.convertToTypeByName(1, "number"),
      storeCode_3: ReactSystemFunctions.convertToTypeByName(null, "string"),
      dateFilter_3: ReactSystemFunctions.convertToTypeByName(1, "number"),
      startDate_3: ReactSystemFunctions.convertToTypeByName(null, "Date"),
      endDate_3: ReactSystemFunctions.convertToTypeByName(null, "Date"),
      pageNumber_3: ReactSystemFunctions.convertToTypeByName(1, "number"),
      storeCode_4: ReactSystemFunctions.convertToTypeByName(null, "string"),
      dateFilter_4: ReactSystemFunctions.convertToTypeByName(1, "number"),
      startDate_4: ReactSystemFunctions.convertToTypeByName(null, "Date"),
      endDate_4: ReactSystemFunctions.convertToTypeByName(null, "Date"),
      pageNumber_4: ReactSystemFunctions.convertToTypeByName(1, "number"),
      Id_6: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
      storeCode_7: ReactSystemFunctions.convertToTypeByName(null, "string"),
      dateFilter_7: ReactSystemFunctions.convertToTypeByName(1, "number"),
      startDate_7: ReactSystemFunctions.convertToTypeByName(null, "Date"),
      endDate_7: ReactSystemFunctions.convertToTypeByName(null, "Date"),
      pageNumber_7: ReactSystemFunctions.convertToTypeByName(1, "number"),
      storeCode_8: ReactSystemFunctions.convertToTypeByName(null, "string"),
      dateFilter_8: ReactSystemFunctions.convertToTypeByName(1, "number"),
      startDate_8: ReactSystemFunctions.convertToTypeByName(null, "Date"),
      endDate_8: ReactSystemFunctions.convertToTypeByName(null, "Date"),
      pageNumber_8: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "MagazaCiroAnaliziOzel/MagazaCiroAnaliziOzelPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetCollectionHeader = result?.data.getCollectionHeader;

    stateVars.GetCollectionReturnHeader =
      result?.data.getCollectionReturnHeader;

    stateVars.GetPaymentHeader = result?.data.getPaymentHeader;

    stateVars.GetPaymentReturnHeader = result?.data.getPaymentReturnHeader;

    stateVars.GetPaymentSummary = result?.data.getPaymentSummary;

    stateVars.GetStoreInfo = result?.data.getStoreInfo;

    formVars.magazaciroanaliziozel_633300_options = stateVars.GetStoreInfo;
    stateVars.GetImage = result?.data.getImage;
    formVars.magazaciroanaliziozel_521690_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetImage !== undefined
        ? stateVars.GetImage?.length > 0
          ? stateVars.GetImage[0].photo
          : null
        : this.state.GetImage?.length > 0
        ? this.state.GetImage[0].photo
        : null
    );
    stateVars.GetPaymentReturnSummary = result?.data.getPaymentReturnSummary;

    stateVars.GetPaymentReturnSummary = result?.data.getPaymentReturnSummary;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.MagazaCiroAnaliziOzelPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MagazaCiroAnaliziOzelPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.magazaciroanaliziozel_521690_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetImage !== undefined
        ? stateVars.GetImage?.length > 0
          ? stateVars.GetImage[0].photo
          : null
        : this.state.GetImage?.length > 0
        ? this.state.GetImage[0].photo
        : null
    );

    stateVars.dataSource_633300 =
      stateVars.GetStoreInfo ?? this.state.GetStoreInfo;
    stateVars.dataSource_633300 =
      stateVars.GetStoreInfo ?? this.state.GetStoreInfo;
    stateVars.isComp324396Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("7", "string")
      ) === true
        ? "visible"
        : "hidden";

    stateVars.dataSource_268575 =
      stateVars.GetCollectionHeader ?? this.state.GetCollectionHeader;

    stateVars.dataSource_196818 =
      stateVars.GetCollectionReturnHeader ??
      this.state.GetCollectionReturnHeader;

    stateVars.dataSource_190713 =
      stateVars.GetPaymentHeader ?? this.state.GetPaymentHeader;

    stateVars.dataSource_60075 =
      stateVars.GetPaymentReturnHeader ?? this.state.GetPaymentReturnHeader;

    stateVars.dataSource_255514 =
      stateVars.GetPaymentSummary ?? this.state.GetPaymentSummary;

    stateVars.dataSource_330689 =
      stateVars.GetPaymentReturnSummary ?? this.state.GetPaymentReturnSummary;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  MagazaCiroAnaliziOzelComponent_891895_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "MagazaCiroAnaliziOzel",
      "LeftMenu",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "488099",
      null,
      "left",
      "true",
      "100vw",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  MagazaCiroAnaliziOzelComponent_976357_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "MagazaCiroAnaliziOzel",
      "ProfileScreen",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  MagazaCiroAnaliziOzelComponent_446097_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);
    KuikaAppManager.increaseServerRequestCount();

    stateVars.Logout = await ReactSystemFunctions.logout();
    stateVars.tmpBoolResult = await ReactSystemFunctions.goToSignInActivity(
      this
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  MagazaCiroAnaliziOzelComponent_633300_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      storeCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_633300_value",
            "value",
            "GetStoreInfo",
            "storeCode",
            "storeCode"
          )
        ),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      startDate_0: ReactSystemFunctions.convertToTypeByName(null, "Date"),
      endDate_0: ReactSystemFunctions.convertToTypeByName(null, "Date"),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    KuikaAppManager.showSpinner(this);
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("7", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "MagazaCiroAnaliziOzel/MagazaCiroAnaliziOzelComponent_633300_onChange",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.GetCollectionHeader = result?.data.getCollectionHeader;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_633300_onChange1_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_633300_onChange1_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MagazaCiroAnaliziOzelComponent_633300_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      storeCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_633300_value",
            "value",
            "GetStoreInfo",
            "storeCode",
            "storeCode"
          )
        ),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      startDate_0: ReactSystemFunctions.convertToTypeByName(null, "Date"),
      endDate_0: ReactSystemFunctions.convertToTypeByName(null, "Date"),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("7", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "MagazaCiroAnaliziOzel/MagazaCiroAnaliziOzelComponent_633300_onChange1_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.GetCollectionReturnHeader =
        result?.data.getCollectionReturnHeader;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_633300_onChange2_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_633300_onChange2_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MagazaCiroAnaliziOzelComponent_633300_onChange2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      storeCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_633300_value",
            "value",
            "GetStoreInfo",
            "storeCode",
            "storeCode"
          )
        ),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      startDate_0: ReactSystemFunctions.convertToTypeByName(null, "Date"),
      endDate_0: ReactSystemFunctions.convertToTypeByName(null, "Date"),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("7", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "MagazaCiroAnaliziOzel/MagazaCiroAnaliziOzelComponent_633300_onChange2_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.GetPaymentHeader = result?.data.getPaymentHeader;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_633300_onChange3_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_633300_onChange3_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MagazaCiroAnaliziOzelComponent_633300_onChange3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      storeCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_633300_value",
            "value",
            "GetStoreInfo",
            "storeCode",
            "storeCode"
          )
        ),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      startDate_0: ReactSystemFunctions.convertToTypeByName(null, "Date"),
      endDate_0: ReactSystemFunctions.convertToTypeByName(null, "Date"),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("7", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "MagazaCiroAnaliziOzel/MagazaCiroAnaliziOzelComponent_633300_onChange3_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.GetPaymentReturnHeader = result?.data.getPaymentReturnHeader;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_633300_onChange4_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_633300_onChange4_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MagazaCiroAnaliziOzelComponent_633300_onChange4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      storeCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_633300_value",
            "value",
            "GetStoreInfo",
            "storeCode",
            "storeCode"
          )
        ),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      startDate_0: ReactSystemFunctions.convertToTypeByName(null, "Date"),
      endDate_0: ReactSystemFunctions.convertToTypeByName(null, "Date"),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("7", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "MagazaCiroAnaliziOzel/MagazaCiroAnaliziOzelComponent_633300_onChange4_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.GetPaymentSummary = result?.data.getPaymentSummary;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_633300_onChange5_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_633300_onChange5_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MagazaCiroAnaliziOzelComponent_633300_onChange5_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("7", "string")
      )
    ) {
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_633300_onChange6_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_633300_onChange6_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  MagazaCiroAnaliziOzelComponent_633300_onChange6_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("7", "string")
      )
    ) {
      stateVars.dataSource_268575 =
        stateVars.GetCollectionHeader ?? this.state.GetCollectionHeader;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_633300_onChange7_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_633300_onChange7_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  MagazaCiroAnaliziOzelComponent_633300_onChange7_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("7", "string")
      )
    ) {
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_633300_onChange8_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_633300_onChange8_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  MagazaCiroAnaliziOzelComponent_633300_onChange8_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("7", "string")
      )
    ) {
      stateVars.dataSource_196818 =
        stateVars.GetCollectionReturnHeader ??
        this.state.GetCollectionReturnHeader;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_633300_onChange9_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_633300_onChange9_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  MagazaCiroAnaliziOzelComponent_633300_onChange9_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("7", "string")
      )
    ) {
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_633300_onChange10_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_633300_onChange10_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  MagazaCiroAnaliziOzelComponent_633300_onChange10_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("7", "string")
      )
    ) {
      stateVars.dataSource_190713 =
        stateVars.GetPaymentHeader ?? this.state.GetPaymentHeader;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_633300_onChange11_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_633300_onChange11_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  MagazaCiroAnaliziOzelComponent_633300_onChange11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("7", "string")
      )
    ) {
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_633300_onChange12_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_633300_onChange12_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  MagazaCiroAnaliziOzelComponent_633300_onChange12_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("7", "string")
      )
    ) {
      stateVars.dataSource_60075 =
        stateVars.GetPaymentReturnHeader ?? this.state.GetPaymentReturnHeader;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_633300_onChange13_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_633300_onChange13_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  MagazaCiroAnaliziOzelComponent_633300_onChange13_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("7", "string")
      )
    ) {
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_633300_onChange14_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_633300_onChange14_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  MagazaCiroAnaliziOzelComponent_633300_onChange14_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("7", "string")
      )
    ) {
      stateVars.dataSource_255514 =
        stateVars.GetPaymentSummary ?? this.state.GetPaymentSummary;

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    } else {
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  MagazaCiroAnaliziOzelComponent_965256_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      storeCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_633300_value",
            "value",
            "GetStoreInfo",
            "storeCode",
            "storeCode"
          )
        ),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      startDate_0: ReactSystemFunctions.convertToTypeByName(null, "Date"),
      endDate_0: ReactSystemFunctions.convertToTypeByName(null, "Date"),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    KuikaAppManager.showSpinner(this);
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("7", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "MagazaCiroAnaliziOzel/MagazaCiroAnaliziOzelComponent_965256_onChange",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.GetCollectionHeader = result?.data.getCollectionHeader;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_965256_onChange1_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_965256_onChange1_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MagazaCiroAnaliziOzelComponent_965256_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      storeCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_633300_value",
            "value",
            "GetStoreInfo",
            "storeCode",
            "storeCode"
          )
        ),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      startDate_0: ReactSystemFunctions.convertToTypeByName(null, "Date"),
      endDate_0: ReactSystemFunctions.convertToTypeByName(null, "Date"),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("7", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "MagazaCiroAnaliziOzel/MagazaCiroAnaliziOzelComponent_965256_onChange1_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.GetCollectionReturnHeader =
        result?.data.getCollectionReturnHeader;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_965256_onChange2_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_965256_onChange2_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MagazaCiroAnaliziOzelComponent_965256_onChange2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      storeCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_633300_value",
            "value",
            "GetStoreInfo",
            "storeCode",
            "storeCode"
          )
        ),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      startDate_0: ReactSystemFunctions.convertToTypeByName(null, "Date"),
      endDate_0: ReactSystemFunctions.convertToTypeByName(null, "Date"),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("7", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "MagazaCiroAnaliziOzel/MagazaCiroAnaliziOzelComponent_965256_onChange2_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.GetPaymentHeader = result?.data.getPaymentHeader;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_965256_onChange3_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_965256_onChange3_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MagazaCiroAnaliziOzelComponent_965256_onChange3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      storeCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_633300_value",
            "value",
            "GetStoreInfo",
            "storeCode",
            "storeCode"
          )
        ),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      startDate_0: ReactSystemFunctions.convertToTypeByName(null, "Date"),
      endDate_0: ReactSystemFunctions.convertToTypeByName(null, "Date"),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("7", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "MagazaCiroAnaliziOzel/MagazaCiroAnaliziOzelComponent_965256_onChange3_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.GetPaymentReturnHeader = result?.data.getPaymentReturnHeader;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_965256_onChange4_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_965256_onChange4_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MagazaCiroAnaliziOzelComponent_965256_onChange4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      storeCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_633300_value",
            "value",
            "GetStoreInfo",
            "storeCode",
            "storeCode"
          )
        ),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      startDate_0: ReactSystemFunctions.convertToTypeByName(null, "Date"),
      endDate_0: ReactSystemFunctions.convertToTypeByName(null, "Date"),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("7", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "MagazaCiroAnaliziOzel/MagazaCiroAnaliziOzelComponent_965256_onChange4_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.GetPaymentSummary = result?.data.getPaymentSummary;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_965256_onChange5_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_965256_onChange5_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MagazaCiroAnaliziOzelComponent_965256_onChange5_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      storeCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_633300_value",
            "value",
            "GetStoreInfo",
            "storeCode",
            "storeCode"
          )
        ),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      startDate_0: ReactSystemFunctions.convertToTypeByName(null, "Date"),
      endDate_0: ReactSystemFunctions.convertToTypeByName(null, "Date"),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("7", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "MagazaCiroAnaliziOzel/MagazaCiroAnaliziOzelComponent_965256_onChange5_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.GetPaymentReturnSummary = result?.data.getPaymentReturnSummary;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_965256_onChange6_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_965256_onChange6_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MagazaCiroAnaliziOzelComponent_965256_onChange6_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.isComp324396Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("7", "string")
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.MagazaCiroAnaliziOzelComponent_965256_onChange7_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  MagazaCiroAnaliziOzelComponent_965256_onChange7_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("7", "string")
      )
    ) {
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_965256_onChange8_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_965256_onChange8_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  MagazaCiroAnaliziOzelComponent_965256_onChange8_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("7", "string")
      )
    ) {
      stateVars.dataSource_268575 =
        stateVars.GetCollectionHeader ?? this.state.GetCollectionHeader;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_965256_onChange9_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_965256_onChange9_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  MagazaCiroAnaliziOzelComponent_965256_onChange9_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("7", "string")
      )
    ) {
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_965256_onChange10_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_965256_onChange10_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  MagazaCiroAnaliziOzelComponent_965256_onChange10_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("7", "string")
      )
    ) {
      stateVars.dataSource_196818 =
        stateVars.GetCollectionReturnHeader ??
        this.state.GetCollectionReturnHeader;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_965256_onChange11_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_965256_onChange11_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  MagazaCiroAnaliziOzelComponent_965256_onChange11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("7", "string")
      )
    ) {
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_965256_onChange12_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_965256_onChange12_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  MagazaCiroAnaliziOzelComponent_965256_onChange12_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("7", "string")
      )
    ) {
      stateVars.dataSource_190713 =
        stateVars.GetPaymentHeader ?? this.state.GetPaymentHeader;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_965256_onChange13_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_965256_onChange13_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  MagazaCiroAnaliziOzelComponent_965256_onChange13_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("7", "string")
      )
    ) {
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_965256_onChange14_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_965256_onChange14_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  MagazaCiroAnaliziOzelComponent_965256_onChange14_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("7", "string")
      )
    ) {
      stateVars.dataSource_60075 =
        stateVars.GetPaymentReturnHeader ?? this.state.GetPaymentReturnHeader;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_965256_onChange15_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_965256_onChange15_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  MagazaCiroAnaliziOzelComponent_965256_onChange15_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("7", "string")
      )
    ) {
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_965256_onChange16_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_965256_onChange16_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  MagazaCiroAnaliziOzelComponent_965256_onChange16_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("7", "string")
      )
    ) {
      stateVars.dataSource_255514 =
        stateVars.GetPaymentSummary ?? this.state.GetPaymentSummary;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_965256_onChange17_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_965256_onChange17_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  MagazaCiroAnaliziOzelComponent_965256_onChange17_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("7", "string")
      )
    ) {
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_965256_onChange18_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_965256_onChange18_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  MagazaCiroAnaliziOzelComponent_965256_onChange18_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("7", "string")
      )
    ) {
      stateVars.dataSource_330689 =
        stateVars.GetPaymentReturnSummary ?? this.state.GetPaymentReturnSummary;

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    } else {
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  MagazaCiroAnaliziOzelComponent_758630_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      storeCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_633300_value",
            "value",
            "GetStoreInfo",
            "storeCode",
            "storeCode"
          )
        ),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      startDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_905610_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      endDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_836291_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    KuikaAppManager.showSpinner(this);
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("7", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "MagazaCiroAnaliziOzel/MagazaCiroAnaliziOzelComponent_758630_onClick",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.GetCollectionHeader = result?.data.getCollectionHeader;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_758630_onClick1_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_758630_onClick1_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MagazaCiroAnaliziOzelComponent_758630_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      storeCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_633300_value",
            "value",
            "GetStoreInfo",
            "storeCode",
            "storeCode"
          )
        ),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      startDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_905610_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      endDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_836291_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("7", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "MagazaCiroAnaliziOzel/MagazaCiroAnaliziOzelComponent_758630_onClick1_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.GetCollectionReturnHeader =
        result?.data.getCollectionReturnHeader;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_758630_onClick2_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_758630_onClick2_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MagazaCiroAnaliziOzelComponent_758630_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      storeCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_633300_value",
            "value",
            "GetStoreInfo",
            "storeCode",
            "storeCode"
          )
        ),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      startDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_905610_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      endDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_836291_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("7", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "MagazaCiroAnaliziOzel/MagazaCiroAnaliziOzelComponent_758630_onClick2_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.GetPaymentHeader = result?.data.getPaymentHeader;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_758630_onClick3_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_758630_onClick3_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MagazaCiroAnaliziOzelComponent_758630_onClick3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      storeCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_633300_value",
            "value",
            "GetStoreInfo",
            "storeCode",
            "storeCode"
          )
        ),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      startDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_905610_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      endDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_836291_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("7", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "MagazaCiroAnaliziOzel/MagazaCiroAnaliziOzelComponent_758630_onClick3_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.GetPaymentReturnHeader = result?.data.getPaymentReturnHeader;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_758630_onClick4_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_758630_onClick4_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MagazaCiroAnaliziOzelComponent_758630_onClick4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      storeCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_633300_value",
            "value",
            "GetStoreInfo",
            "storeCode",
            "storeCode"
          )
        ),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      startDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_905610_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      endDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_836291_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("7", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "MagazaCiroAnaliziOzel/MagazaCiroAnaliziOzelComponent_758630_onClick4_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.GetPaymentSummary = result?.data.getPaymentSummary;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_758630_onClick5_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_758630_onClick5_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MagazaCiroAnaliziOzelComponent_758630_onClick5_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      storeCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_633300_value",
            "value",
            "GetStoreInfo",
            "storeCode",
            "storeCode"
          )
        ),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      startDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_905610_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      endDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_836291_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("7", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "MagazaCiroAnaliziOzel/MagazaCiroAnaliziOzelComponent_758630_onClick5_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.GetPaymentReturnSummary = result?.data.getPaymentReturnSummary;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_758630_onClick6_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_758630_onClick6_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MagazaCiroAnaliziOzelComponent_758630_onClick6_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("7", "string")
      )
    ) {
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_758630_onClick7_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_758630_onClick7_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  MagazaCiroAnaliziOzelComponent_758630_onClick7_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("7", "string")
      )
    ) {
      stateVars.dataSource_268575 =
        stateVars.GetCollectionHeader ?? this.state.GetCollectionHeader;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_758630_onClick8_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_758630_onClick8_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  MagazaCiroAnaliziOzelComponent_758630_onClick8_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("7", "string")
      )
    ) {
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_758630_onClick9_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_758630_onClick9_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  MagazaCiroAnaliziOzelComponent_758630_onClick9_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("7", "string")
      )
    ) {
      stateVars.dataSource_196818 =
        stateVars.GetCollectionReturnHeader ??
        this.state.GetCollectionReturnHeader;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_758630_onClick10_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_758630_onClick10_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  MagazaCiroAnaliziOzelComponent_758630_onClick10_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("7", "string")
      )
    ) {
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_758630_onClick11_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_758630_onClick11_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  MagazaCiroAnaliziOzelComponent_758630_onClick11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("7", "string")
      )
    ) {
      stateVars.dataSource_190713 =
        stateVars.GetPaymentHeader ?? this.state.GetPaymentHeader;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_758630_onClick12_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_758630_onClick12_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  MagazaCiroAnaliziOzelComponent_758630_onClick12_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("7", "string")
      )
    ) {
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_758630_onClick13_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_758630_onClick13_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  MagazaCiroAnaliziOzelComponent_758630_onClick13_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("7", "string")
      )
    ) {
      stateVars.dataSource_60075 =
        stateVars.GetPaymentReturnHeader ?? this.state.GetPaymentReturnHeader;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_758630_onClick14_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_758630_onClick14_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  MagazaCiroAnaliziOzelComponent_758630_onClick14_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("7", "string")
      )
    ) {
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_758630_onClick15_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_758630_onClick15_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  MagazaCiroAnaliziOzelComponent_758630_onClick15_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("7", "string")
      )
    ) {
      stateVars.dataSource_255514 =
        stateVars.GetPaymentSummary ?? this.state.GetPaymentSummary;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_758630_onClick16_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_758630_onClick16_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  MagazaCiroAnaliziOzelComponent_758630_onClick16_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("7", "string")
      )
    ) {
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_758630_onClick17_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MagazaCiroAnaliziOzelComponent_758630_onClick17_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  MagazaCiroAnaliziOzelComponent_758630_onClick17_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanaliziozel_965256_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("7", "string")
      )
    ) {
      stateVars.dataSource_330689 =
        stateVars.GetPaymentReturnSummary ?? this.state.GetPaymentReturnSummary;

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    } else {
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  MagazaCiroAnaliziOzelComponent_688516_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "magazaciroanaliziozel_633300_value",
        "string"
      ),
      "",
      null,
      "StoreCode"
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "magazaciroanaliziozel_965256_value",
        "string"
      ),
      ReactSystemFunctions.convertToTypeByName("1", "string"),
      null,
      "Key"
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "magazaciroanaliziozel_905610_value",
        "string"
      ),
      "",
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "magazaciroanaliziozel_836291_value",
        "string"
      ),
      "",
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.MagazaCiroAnaliziOzelComponent_688516_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  MagazaCiroAnaliziOzelComponent_688516_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      storeCode_0: ReactSystemFunctions.convertToTypeByName(null, "string"),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
      startDate_0: ReactSystemFunctions.convertToTypeByName(null, "Date"),
      endDate_0: ReactSystemFunctions.convertToTypeByName(null, "Date"),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
      storeCode_1: ReactSystemFunctions.convertToTypeByName(null, "string"),
      dateFilter_1: ReactSystemFunctions.convertToTypeByName(1, "number"),
      startDate_1: ReactSystemFunctions.convertToTypeByName(null, "Date"),
      endDate_1: ReactSystemFunctions.convertToTypeByName(null, "Date"),
      pageNumber_1: ReactSystemFunctions.convertToTypeByName(1, "number"),
      storeCode_2: ReactSystemFunctions.convertToTypeByName(null, "string"),
      dateFilter_2: ReactSystemFunctions.convertToTypeByName(1, "number"),
      startDate_2: ReactSystemFunctions.convertToTypeByName(null, "Date"),
      endDate_2: ReactSystemFunctions.convertToTypeByName(null, "Date"),
      pageNumber_2: ReactSystemFunctions.convertToTypeByName(1, "number"),
      storeCode_3: ReactSystemFunctions.convertToTypeByName(null, "string"),
      dateFilter_3: ReactSystemFunctions.convertToTypeByName(1, "number"),
      startDate_3: ReactSystemFunctions.convertToTypeByName(null, "Date"),
      endDate_3: ReactSystemFunctions.convertToTypeByName(null, "Date"),
      pageNumber_3: ReactSystemFunctions.convertToTypeByName(1, "number"),
      storeCode_4: ReactSystemFunctions.convertToTypeByName(null, "string"),
      dateFilter_4: ReactSystemFunctions.convertToTypeByName(1, "number"),
      startDate_4: ReactSystemFunctions.convertToTypeByName(null, "Date"),
      endDate_4: ReactSystemFunctions.convertToTypeByName(null, "Date"),
      pageNumber_4: ReactSystemFunctions.convertToTypeByName(1, "number"),
      storeCode_5: ReactSystemFunctions.convertToTypeByName(null, "string"),
      dateFilter_5: ReactSystemFunctions.convertToTypeByName(1, "number"),
      startDate_5: ReactSystemFunctions.convertToTypeByName(null, "Date"),
      endDate_5: ReactSystemFunctions.convertToTypeByName(null, "Date"),
      pageNumber_5: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "MagazaCiroAnaliziOzel/MagazaCiroAnaliziOzelComponent_688516_onClick1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetCollectionHeader = result?.data.getCollectionHeader;

    stateVars.GetCollectionReturnHeader =
      result?.data.getCollectionReturnHeader;

    stateVars.GetPaymentHeader = result?.data.getPaymentHeader;

    stateVars.GetPaymentSummary = result?.data.getPaymentSummary;

    stateVars.GetPaymentReturnHeader = result?.data.getPaymentReturnHeader;

    stateVars.GetPaymentReturnSummary = result?.data.getPaymentReturnSummary;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.MagazaCiroAnaliziOzelComponent_688516_onClick2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MagazaCiroAnaliziOzelComponent_688516_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_268575 =
      stateVars.GetCollectionHeader ?? this.state.GetCollectionHeader;

    stateVars.dataSource_196818 =
      stateVars.GetCollectionReturnHeader ??
      this.state.GetCollectionReturnHeader;

    stateVars.dataSource_190713 =
      stateVars.GetPaymentHeader ?? this.state.GetPaymentHeader;

    stateVars.dataSource_60075 =
      stateVars.GetPaymentReturnHeader ?? this.state.GetPaymentReturnHeader;

    stateVars.dataSource_255514 =
      stateVars.GetPaymentSummary ?? this.state.GetPaymentSummary;

    stateVars.dataSource_330689 =
      stateVars.GetPaymentReturnSummary ?? this.state.GetPaymentReturnSummary;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [488099] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.MagazaCiroAnaliziOzelPageInit();
    }
  }
}
